<template>
  <div>
    <Modal @closeModal="$emit('close-triggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="font-weight-bold">ADD CLASS</span>
      </div>
      <!-- MODAL BODY -->
      <div slot="modal-body">
        <!-- ERROR ALERT -->
        <div class="alert-comp">
          <AuthAlertCard
            v-if="show_alert"
            :alert_type="alert_type"
            :alert_msg="alert_msg"
          ></AuthAlertCard>
        </div>

        <SetupForm
          :show_invite="false"
          @find-class="toggleFindClassModal"
          @toggle-invite-form="toggleInvite(true)"
          @classCodeSubmitted="verifyClassCode"
          :school_name="school_name"
          :class_name="class_name"
        ></SetupForm>

        <div class="row mt-md-3 button-row">
          <div class="col-12 d-flex justify-content-center align-items-center">
            <button
              class="btn btn-md btn-primary"
              @click="addTeacher"
              ref="addBtn"
              :disabled="isDisabled"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </Modal>

    <!-- MODAL -->
    <FindClassModal
      v-if="find_class"
      @close-triggered="toggleFindClassModal"
      @joined="cleanUp"
    ></FindClassModal>

    <InviteSchoolModal
      v-if="invite_school"
      @school-invite="toggleInvite(false)"
      @close-triggered="toggleInvite(false)"
    ></InviteSchoolModal>
    <!-- MODAL -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";
import SetupForm from "@/components/teachersComps/onboarding/SetupForm";

export default {
  name: "AddClassModal",

  components: {
    Modal,
    SetupForm,
    FindClassModal: () =>
      import(
        /* webpackChunkName: "FindClassmodal" */ "@/components/modalComps/teacherModals/FindClassModal"
      ),
    InviteSchoolModal: () =>
      import(
        /* webpackChunkName: "FindClassmodal" */ "@/components/modalComps/teacherModals/InviteSchoolModal"
      ),
    AuthAlertCard: () =>
      import(
        /* webpackChunkName: "AuthAlertCard" */ "@/components/globalComps/AuthComps/AuthAlertCard.vue"
      ),
  },

  data() {
    return {
      find_class: false,
      class: null,
      disabled: true,
      school_name: null,
      class_name: null,
      invite_school: false,

      show_alert: false,
      alert_type: null, //SET TO EITHER SUCCESS OR ERROR
      alert_msg: null,
    };
  },

  computed: {
    isDisabled() {
      return this.disabled;
    },
  },

  methods: {
    ...mapActions(["addTeacherToClassByClassCode", "getClassDetails"]),

    toggleFindClassModal() {
      this.find_class = !this.find_class;
    },

    verifyClassCode(code) {
      this.getClassDetails(code)
        .then((res) => {
          // ENABLE BUTTON AND SET CLASS CODE DATA PROPERTY IF VERIFIED
          if (res.data.code == 200) {
            //SET CLASS NAME AND SCHOOL NAME
            this.class_name = res.data.data.class_name;
            this.school_name = res.data.data.school.name;
            this.class = res.data.data;

            this.showMsg("success", "Class code verified");
            this.disabled = false;
          } else {
            this.disabled = true;
            this.class_name = null;
            this.school_name = null;
            this.showMsg("error", res.data.message);
          }
        })
        .catch((err) => console.warn(err));
    },

    addTeacher() {
      this.$refs.addBtn.disabled = true;
      this.$refs.addBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 animate mr-2"></div>Please wait ...';

      this.addTeacherToClassByClassCode(this.class.class_code).then((res) => {
        // CLOSE MODAL AND REFETCH TEACHER'S CLASS(ES) IF SUCCESSFUL
        if (res.data.code == 200) {
          this.showMsg(
            "success",
            `You have been successfully added to ${this.class_name}`
          );

          this.$refs.addBtn.disabled = false;
          this.$refs.addBtn.innerHTML =
            '<div class="icon-accept font-18 mr-2"></div>Done';

          setTimeout(() => {
            this.$emit("close-triggered");
            this.$emit("teacher-added");
          }, 3000);
        } else {
          this.showMsg("error", res.data.message);
        }
      });
    },

    showMsg(alertType, alertMessage) {
      this.show_alert = true;
      this.alert_type = alertType;
      this.alert_msg = alertMessage;

      setTimeout(() => {
        this.show_alert = false;
      }, 4000);
    },

    cleanUp() {
      this.$emit("teacher-added");
      this.$emit("close-triggered");
    },

    toggleInvite(val) {
      this.invite_school = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-comp {
  position: relative;
  top: -40px;
  margin-bottom: -15px;
}

.button-row {
  @include breakpoint_max(sm) {
    margin-top: -10px !important;
    margin-bottom: -10px !important;
  }
}
</style>
